var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExitIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6699 20.0002H35.0067",
    stroke: "#9192AD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6719 23.335L35.0066 20.0002L31.6719 16.6655",
    stroke: "#9192AD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3389 28.337V31.6717C33.3389 33.5141 31.8466 35.0064 30.0042 35.0064H9.99585C8.15342 35.0064 6.66113 33.5141 6.66113 31.6717V8.32862C6.66113 6.48618 8.15342 4.9939 9.99585 4.9939H30.0042C31.8466 4.9939 33.3389 6.48618 33.3389 8.32862V11.6633",
    stroke: "#9192AD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9977 18.3328V21.6675",
    stroke: "#9192AD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66113 31.6667C6.66113 34.146 9.27055 35.7584 11.4865 34.6496L18.1559 31.3149C19.2864 30.748 20 29.5941 20 28.3303V4.9939",
    stroke: "#9192AD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitIcon);
export default __webpack_public_path__ + "static/media/exit-icon.935a38dd9e74567383a035cf2ea38ef0.svg";
export { ForwardRef as ReactComponent };